module.exports = __webpack_public_path__ + "static/Rezgo-795c9cddd35517f980f3f7f3ca6ae25a.svg";